import { render } from "./App.vue?vue&type=template&id=3ff56cb5&ts=true"
import script from "./App.ts?vue&type=script&lang=ts"
export * from "./App.ts?vue&type=script&lang=ts"

import "./App.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__